import {
  BatchTohanBooksOrderDataCreateConditionListItem,
  BatchTohanBooksOrderDataCreateConditionListItemFromJSON
} from '@/api/models/batch/BatchTohanBooksOrderDataCreateConditionListItem'

export interface BatchTohanBooksOrderDataCreatePageLoadResult {
  items: BatchTohanBooksOrderDataCreateConditionListItem
}

export function BatchTohanBooksOrderDataCreatePageLoadResultFromJSON(
  json: any
): BatchTohanBooksOrderDataCreatePageLoadResult {
  return {
    items: BatchTohanBooksOrderDataCreateConditionListItemFromJSON(json)
  }
}
